import {
  Atom,
  HeadCircuit,
  Images,
  ListMagnifyingGlass,
  PencilSimple,
  Video,
} from '@phosphor-icons/react';
import { SkillCommandToggle } from '../SkillCommandToggle';
import { QuickSkillCommand } from 'src/types';
import {
  DrawerTooltipContainer,
  DrawerTooltipContainerRef,
} from 'src/v2/commonComponents/DrawerTooltipContainer';
import { useRef } from 'react';
import { SkillCommandMoreToggle } from '../SkillCommandMoreToggle';
import styles from './SkillCommandSection.module.scss';
import {
  useBreakpoint,
  useComparingConversationsParams,
  useConversationParams,
  useRightSidePanelState,
} from 'src/hooks';
import { NOT_AVAILABLE_IN_COMPARE_MODE } from 'src/constants';
import { SNLink } from '../SNLink';

const TOOLTIP_ID = 'skill-command-more-tooltip';

export const SkillCommandSection = () => {
  const drawerRef = useRef<DrawerTooltipContainerRef>(null);

  const { isDesktopAndUp } = useBreakpoint();
  const { isLandingPage } = useConversationParams();
  const { isCompareMode } = useComparingConversationsParams();
  const { isRightPanelExpanded } = useRightSidePanelState();

  const handleClick = () => {
    drawerRef.current?.onVisibilityToggle();
  };

  return (
    <div className={styles.root}>
      <SNLink />

      <SkillCommandToggle
        command={QuickSkillCommand.DEEP_RESEARCHER}
        Icon={Atom}
        title="Deep Research"
        tooltipContent={
          isCompareMode
            ? NOT_AVAILABLE_IN_COMPARE_MODE
            : 'Advanced online research and reasoning'
        }
        onClick={handleClick}
      />

      <SkillCommandToggle
        command={QuickSkillCommand.RESEARCHER}
        Icon={ListMagnifyingGlass}
        title="Fast Search"
        tooltipContent="Online fast research"
        onClick={handleClick}
      />

      <SkillCommandToggle
        command={QuickSkillCommand.WRITER}
        Icon={PencilSimple}
        title="Write/Code"
        tooltipContent="Write, brainstorm, get advice"
        onClick={handleClick}
      />

      {!isRightPanelExpanded && isDesktopAndUp && (
        <>
          <SkillCommandToggle
            command={QuickSkillCommand.IMAGE}
            Icon={Images}
            title="Image"
            tooltipContent={
              isCompareMode
                ? NOT_AVAILABLE_IN_COMPARE_MODE
                : 'Create & edit images'
            }
            onClick={handleClick}
          />
        </>
      )}

      {!isDesktopAndUp && (
        <>
          <SkillCommandToggle
            command={QuickSkillCommand.IMAGE}
            Icon={Images}
            title="Image"
            tooltipContent={
              isCompareMode
                ? NOT_AVAILABLE_IN_COMPARE_MODE
                : 'Create & edit images'
            }
            onClick={handleClick}
          />

          <SkillCommandToggle
            command={QuickSkillCommand.THINKING}
            Icon={HeadCircuit}
            title="Think"
            tooltipContent="Step-by-step problem solving"
            onClick={handleClick}
          />

          <SkillCommandToggle
            command={QuickSkillCommand.VIDEO}
            Icon={Video}
            title="Video"
            tooltipContent="Create video"
            onClick={handleClick}
          />
        </>
      )}

      {isDesktopAndUp && (
        <DrawerTooltipContainer
          ToggleButton={SkillCommandMoreToggle}
          ref={drawerRef}
          onlyTooltip
          id={TOOLTIP_ID}
          place={isLandingPage ? 'bottom-end' : 'top'}
          classNameTooltip={styles.tooltip}
        >
          <div className={styles.tooltipContainer}>
            {isRightPanelExpanded && (
              <>
                <SkillCommandToggle
                  command={QuickSkillCommand.IMAGE}
                  Icon={Images}
                  title="Image"
                  tooltipContent={
                    isCompareMode
                      ? NOT_AVAILABLE_IN_COMPARE_MODE
                      : 'Create & edit images'
                  }
                  onClick={handleClick}
                  fullWidth
                />
              </>
            )}

            <SkillCommandToggle
              command={QuickSkillCommand.THINKING}
              Icon={HeadCircuit}
              title="Think"
              tooltipContent="Step-by-step problem solving"
              onClick={handleClick}
              fullWidth
            />

            <SkillCommandToggle
              command={QuickSkillCommand.VIDEO}
              Icon={Video}
              title="Video"
              tooltipContent="Create video"
              onClick={handleClick}
              fullWidth
            />
          </div>
        </DrawerTooltipContainer>
      )}
    </div>
  );
};
